const styles = {
  container:
    "max-w-screen mx-6 sm:mx-12 flex flex-col grow items-center h-full",
  content: "max-w-[96rem] w-full flex flex-col grow",
};

export default styles;
